window.addEventListener('DOMContentLoaded', (event) => {
   var qwerty = document.querySelector("details#Details-HeaderMenu-2");
  qwerty.addEventListener("mouseover", () => {
    document.querySelector("details#Details-HeaderMenu-2").setAttribute("open", true);
  });
  var qwerty1 = document.querySelector("ul#HeaderMenu-MenuList-2");
    qwerty1.addEventListener("mouseleave", () => {
    document.querySelector("details#Details-HeaderMenu-2").removeAttribute("open");
  });

  window.onscroll = function() {myFunction()};

  var header = document.querySelector("sticky-header.header-wrapper");
  var sticky = header.offsetTop;
  
  function myFunction() {
    if (window.pageYOffset > 500) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }
});

